<div class="modal-header">
  <h5 class="modal-title">{{ titre }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-3">
  <form>
    <div class="row mb-3 align-items-end">
      <div class="col-md-6 d-flex align-items-end gap-2">
        <button (click)="imprimer()" type="button" class="btn btn-primary">
          <i class="mdi mdi-printer me-1"></i> Imprimer
        </button>
        <button (click)="toggleHistogramme()" type="button" class="btn btn-secondary">
          <i class="mdi mdi-chart-bar me-1"></i> Histogramme
        </button>
      </div>
      <div class="col-md-6 d-flex justify-content-end align-items-end gap-2">
        <div class="form-group mb-0">
          <label class="mb-0">Début période <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="jj/mm/aaaa" maxlength="10" [(ngModel)]="dateDebutDisplay" name="dateDebut">
        </div>
        <div class="form-group mb-0">
          <label class="mb-0">Fin période <span class="text-danger">*</span></label>
          <input type="text" class="form-control" placeholder="jj/mm/aaaa" maxlength="10" [(ngModel)]="dateFinDisplay" name="dateFin">
        </div>
        <button (click)="loadData()" type="button" class="btn btn-info">
          <i class="mdi mdi-magnify me-1"></i> Recherche
        </button>
      </div>
    </div>

    <div *ngIf="showHistogramme && chartData" class="card mb-3">
      <div class="card-body">
        <p-chart type="bar" [data]="chartData" [options]="chartOptions" height="220px"></p-chart>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-centered datatable dt-responsive nowrap"
        style="border-collapse: collapse; border-spacing: 0; width: 100%;">
        <thead class="thead-light rwd-table">
          <tr>
            <th>Code</th>
            <th>Compte budgétaire</th>
            <th class="text-end">Prévision annuelle</th>
            <th class="text-end">Titre des recettes nettes</th>
            <th>Taux de réalisation</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of synthese">
            <td>{{ item.code }}</td>
            <td>{{ item.compte_budgetaire }}</td>
            <td class="text-end">{{ item.prevision_annuelle | number:'1.0-0' }}</td>
            <td class="text-end">{{ item.titre_recettes_nettes | number:'1.0-0' }}</td>
            <td>
              <div class="d-flex align-items-center gap-2">
                <div class="progress flex-grow-1" style="height: 8px;">
                  <div class="progress-bar bg-success" role="progressbar"
                    [style.width.%]="getTaux(item) > 100 ? 100 : getTaux(item)">
                  </div>
                </div>
                <span class="fw-bold">{{ getTaux(item) }}%</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="synthese.length === 0 && isLoaded" class="d-flex justify-content-center">
      <h5 id="graycolor">Aucune donnée de synthèse pour cette période</h5>
    </div>

    <div class="text-end mt-3">
      <button (click)="close()" type="button" class="btn btn-light">
        <i class="pi pi-times" style="color: #212529"></i> Fermer
      </button>
    </div>
  </form>
</div>
